/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AccountRequest } from '../models';
import { AccountViewIEnumerableResponse } from '../models';
import { BankBranchRequest } from '../models';
import { BankBranchViewIEnumerableResponse } from '../models';
/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Delete Account
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountDeleteAccountAccountIdDelete: async (accountId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId','Required parameter accountId was null or undefined when calling apiV2AccountDeleteAccountAccountIdDelete.');
            }
            const localVarPath = `/api/v2/Account/DeleteAccount/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Accounts by PractiecId
         * @param {number} practiceId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetAccountsByPracticeIdPracticeIdGet: async (practiceId: number, accountTypeId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2AccountGetAccountsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Account/GetAccountsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (accountTypeId !== undefined) {
                localVarQueryParameter['accountTypeId'] = accountTypeId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Returns Bank Branches
         * @param {BankBranchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetBankBranchByKeywordSearchPost: async (body?: BankBranchRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Account/GetBankBranchByKeywordSearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Save Account
         * @param {AccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountSaveAccountPost: async (body?: AccountRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Account/SaveAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Delete Account
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountDeleteAccountAccountIdDelete(accountId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountViewIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV2AccountDeleteAccountAccountIdDelete(accountId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Accounts by PractiecId
         * @param {number} practiceId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId: number, accountTypeId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountViewIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId, accountTypeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Returns Bank Branches
         * @param {BankBranchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountGetBankBranchByKeywordSearchPost(body?: BankBranchRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankBranchViewIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV2AccountGetBankBranchByKeywordSearchPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Save Account
         * @param {AccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountSaveAccountPost(body?: AccountRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountViewIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV2AccountSaveAccountPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Delete Account
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountDeleteAccountAccountIdDelete(accountId: number, options?: any): AxiosPromise<AccountViewIEnumerableResponse> {
            return AccountApiFp(configuration).apiV2AccountDeleteAccountAccountIdDelete(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Accounts by PractiecId
         * @param {number} practiceId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId: number, accountTypeId?: number, options?: any): AxiosPromise<AccountViewIEnumerableResponse> {
            return AccountApiFp(configuration).apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId, accountTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Returns Bank Branches
         * @param {BankBranchRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetBankBranchByKeywordSearchPost(body?: BankBranchRequest, options?: any): AxiosPromise<BankBranchViewIEnumerableResponse> {
            return AccountApiFp(configuration).apiV2AccountGetBankBranchByKeywordSearchPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Save Account
         * @param {AccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountSaveAccountPost(body?: AccountRequest, options?: any): AxiosPromise<AccountViewIEnumerableResponse> {
            return AccountApiFp(configuration).apiV2AccountSaveAccountPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Delete Account
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV2AccountDeleteAccountAccountIdDelete(accountId: number, options?: any) {
        return AccountApiFp(this.configuration).apiV2AccountDeleteAccountAccountIdDelete(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Accounts by PractiecId
     * @param {number} practiceId 
     * @param {number} [accountTypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId: number, accountTypeId?: number, options?: any) {
        return AccountApiFp(this.configuration).apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId, accountTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Returns Bank Branches
     * @param {BankBranchRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV2AccountGetBankBranchByKeywordSearchPost(body?: BankBranchRequest, options?: any) {
        return AccountApiFp(this.configuration).apiV2AccountGetBankBranchByKeywordSearchPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Save Account
     * @param {AccountRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV2AccountSaveAccountPost(body?: AccountRequest, options?: any) {
        return AccountApiFp(this.configuration).apiV2AccountSaveAccountPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
